import { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const Chart1 = () => {
    const chartRef = useRef<HTMLDivElement>(null);
    const chartInstance = useRef<ApexCharts | null>(null);

    useEffect(() => {
        if (!chartRef.current) return;

        const options = {
            series: [
                {
                    data: [
                        47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41,
                        35, 27, 53, 53, 61, 27, 54, 43, 19, 46,
                    ],
                },
            ],
            chart: {
                type: 'area',
                height: 70,
                sparkline: {
                    enabled: true,
                },
                dropShadow: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    top: 0,
                    left: 0,
                    blur: 3,
                    color: 'rgba(var(--success-rgb))',
                    opacity: 0.4,
                },
            },
            stroke: {
                curve: 'smooth', // 곡선
                width: 1,
            },
            fill: {
                type: 'gradient',
                gradient: {
                    opacityFrom: 0.5,
                    opacityTo: 0.2,
                    stops: [0, 60],
                    colorStops: [
                        [
                            {
                                offset: 0,
                                color: 'rgba(var(--success-rgb))',
                                opacity: 0.3,
                            },
                            {
                                offset: 60,
                                color: 'rgba(var(--success-rgb))',
                                opacity: 0.2,
                            },
                        ],
                    ],
                },
            },
            colors: ['rgba(var(--success-rgb))'],
            tooltip: {
                fixed: {
                    enabled: false,
                },
                x: {
                    show: false,
                },
                y: {
                    title: {
                        formatter: function () {
                            return '';
                        },
                    },
                },
            },
        };

        chartInstance.current = new ApexCharts(chartRef.current, options);
        chartInstance.current.render();

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);

    return (
        <>
            <div className="card custom-card overflow-hidden">
                <div className="">
                    <div className="card-body">
                        <div className="d-flex align-items-center w-100 justify-content-between gap-1">
                            <div>
                                <p className="mb-1 text-muted fw-medium">
                                    예측수확량
                                </p>
                                <h4 className="mb-0 fw-medium">924kg</h4>
                            </div>
                            <div className="ms-auto text-end">
                                <span className="badge bg-success rounded-pill align-items-center fs-11">
                                    <i className="ri-arrow-left-up-line fs-11"></i>{' '}
                                    2.5%
                                </span>
                                <div className="text-muted fs-12 mt-1">
                                    지난주보다
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={chartRef}
                        id="employees"
                        style={{
                            marginTop: -20,
                        }}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
